module.exports = {
  process: {
    env: 'Should not be called in the browser',
    exit: 'Should not be called in the browser',
    stdin: 'Should not be called in the browser',
    stdout: 'Should not be called in the browser'
  },
  child_process: 'Should not be called in the browser',
  fs: {
    existsSync: () => false
  },
  ArgumentParser: 'Should not be called in the browser',
  readline: 'Should not be called in the browser',
  jsonDiff: 'Should not be called in the browser',
  sortJson: 'Should not be called in the browser',
  util: 'Should not be called in the browser',
  performance: 'Should not be called in the browser'
}
